import MicroModal from 'micromodal';
import { initSelectVariant } from './selectVariant';
import { closeSliderCart } from '../slider-cart';
import { getProductJson } from './helpers';
import { openOutOfStockUpsell } from '../out-of-stock-upsell';
import { getSizedImageURL, preloadImages } from '../../core/images';
import { propagateWishlistStateToStickyAddToCart } from '../../components/wishlist';
import TabsAutomatic from '../../components/tabs';
import initSizeGuide from '../size-guide';
import Fits from './fits';
import { initAccordion } from '../../components/accordion';
import initInstallmentsModal from '../../components/modals/installments-modal';
import DeliveryEstimate from './delivery-estimate';

let selected_variant_id = '';
const show_zoom_loading = false;
let is_mobile_move = false;

export default () => {
  if (!document.querySelector('body').classList.contains('template-pdp')) {
    return false;
  }

  // Save review anchor if any when coming from plp / search since it will be lost on variant change
  const reviewAnchor = window.location.hash;
  if (reviewAnchor && reviewAnchor.includes('#pdp-reviews-anchor')) {
    sessionStorage.setItem('review-anchor', reviewAnchor);
  }

  new Fits();
  initSelectVariant();
  const pdp_version = (document.querySelector('.template-product-new')) ? 4 : 3;

  if (pdp_version === 3) {
    const tablist = document.querySelector('.product-overview-v3 .product-extra-v3 [role=tablist]');
    if (tablist) {
      new TabsAutomatic(tablist);
    }
  }

  if (pdp_version === 4) {
    const accordion = document.querySelector('.product-overview-v4 .product-details .has-accordion');
    if (accordion) {
      initAccordion('.product-overview-v4 .product-details .has-accordion');
    }

    initInstallmentsModal();
    new DeliveryEstimate();

    // Scroll to review anchor if any
    setTimeout(() => {
      const reviewAnchor = sessionStorage.getItem('review-anchor');
      if (reviewAnchor && reviewAnchor.includes('#pdp-reviews-anchor')) {
        sessionStorage.removeItem('review-anchor');
        window.location.hash = reviewAnchor;
      }
    }, 1000);
  }

  window.addEventListener('load', () => {
    const product = getProductJson();
    if (product.available === false) {
      openOutOfStockUpsell();
    }
  });

  // Note: the add to cart button functionality is handled with slider-cart/index.js when submitting form[action^="/cart/add"]
  document.addEventListener('click', (e) => {
    // Size Guide Modal
    if (e.target.matches('[data-modal="#size-guide-modal"], [data-modal="#size-guide-modal"] *')) {
      e.preventDefault();
      
      closeSliderCart();
      MicroModal.show('size-guide-modal', {
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: (modal) => {
          initSizeGuide();

          // document.querySelectorAll('.blocker').forEach(el => el.classList.add('blocker--size-guide-modal'));

          // [ADA]
          // const closeBtn = document.querySelector('#size-guide-modal .close-modal');
          // if (closeBtn) {
          //   closeBtn.setAttribute('role', 'button');
          //   closeBtn.focus();
          // }
          document.querySelectorAll('#size-guide-modal .ada-descriptive-text').forEach(el => {
            el.setAttribute('tabindex', '0');
            el.classList.add('visually-hidden');
          });

          // Scroll to top of the modal container
          const modalContainer = modal.querySelector('.modal__container');
          if (modalContainer) {
            window.setTimeout(() => {
              modalContainer.scrollTop = 0;
            }, 500);
          }
        },
        onClose: (modal) => {
          // [ADA] We don't want to get the focus back at the beginning of the page
          // Focus the 1st active size or the 1st size option
          const sizeOptions = document.querySelectorAll('[data-product-option-size]');
          let focused = false;
          
          sizeOptions.forEach(option => {
            const li = option.closest('ul')?.querySelector('li.active');
            if (!focused && li) {
              const activeOption = li.querySelector('[data-product-option-size]');
              if (activeOption) {
                activeOption.focus();
                focused = true;
              }
            }
          });
          
          if (!focused && sizeOptions.length) {
            sizeOptions[0].focus();
          }
        }
      });
    }

    // Installments Modal
    /*if (e.target.closest('[data-open-installments-modal]')) {
      e.preventDefault();
      const trigger = e.target.closest('[data-open-installments-modal]');
      const isShopPay = trigger.dataset.openInstallmentsModal === 'shoppay';
      const isAfterpay = trigger.dataset.openInstallmentsModal === 'afterpay';
      const modal = document.querySelector('[data-installments-modal]');

      MicroModal.show(modal.id, {
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: (modal) => {
          // Reset visibility
          modal.querySelectorAll('[data-installments-icon-shoppay], [data-installments-icon-afterpay], [data-installments-desc-shoppay], [data-installments-desc-afterpay]').forEach(el => el.classList.add('visually-hidden'));

          if (isShopPay) {
             modal.querySelector('[data-installments-icon-shoppay]')?.classList.remove('visually-hidden');
             modal.querySelector('[data-installments-desc-shoppay]')?.classList.remove('visually-hidden');
          } else if (isAfterpay) {
             modal.querySelector('[data-installments-icon-afterpay]')?.classList.remove('visually-hidden');
             modal.querySelector('[data-installments-desc-afterpay]')?.classList.remove('visually-hidden');
          }
        },
        onClose: (modal) => {
          // [ADA] Focus the product-free-shipping element
          const installmentsTrigger = document.querySelector('.product-free-shipping');
          if (installmentsTrigger) {
            installmentsTrigger.focus();
          }
        }
      });
    }*/

    // Product zoom thumb
    /*
    if (e.target.matches('[data-product-zoom-thumb], [data-product-zoom-thumb] *')) {
      const item = e.target.closest('[data-product-zoom-thumb]');
      document.querySelector('[data-zoom-full]').innerHTML = `<img src="${item.dataset.productZoomUrl}" alt="Zoomed image" width="100%" onclick="MicroModal.close('zoom-modal');" class="product-zoom__image" tabindex="-1">`;
    }
    */

    // Zoom Modal
    if (e.target.matches('[data-modal="#zoom-modal"], [data-modal="#zoom-modal"] *')) {
      if (window.theme.breakpoints.current === 'mobile' && is_mobile_move) {
        is_mobile_move = false;
        return;
      }

      e.preventDefault();

      const zoomTrigger = e.target.closest('[data-modal="#zoom-modal"]');
      const zoom_image = zoomTrigger?.dataset.zoom;
      const zoom_image_alt = zoomTrigger?.getAttribute('alt');
      const zoom_image_tmp = zoomTrigger?.getAttribute('src');

      MicroModal.show('zoom-modal', {
        disableScroll: true,
        awaitOpenAnimation: true,
        onShow: () => {
          const zoomModalContent = document.querySelector('[data-product-zoom-modal]');
          if (!zoomModalContent) return;

          if (show_zoom_loading) {
            zoomModalContent.innerHTML = `
              <img loading="lazy" src="${zoom_image_tmp}" width="100" alt="${zoom_image_alt}" class="product-zoom__preload" />
              <div class="product-zoom__loader">
                <img loading="lazy" src="${zoomModalContent.dataset.loader}" width="100" alt="Loading..." />
                <p>Loading HD image...</p>
              </div>
            `;
          } else {
            zoomModalContent.innerHTML = `
              <img loading="lazy" src="${zoom_image_tmp}" width="100" alt="${zoom_image_alt}" class="product-zoom__preload" onclick="MicroModal.close('zoom-modal');" tabindex="-1" />
            `;
          }

          preloadImages([zoom_image], () => {
            if (!zoom_image || !zoom_image_alt) {
              console.warn('Zoom image or alt text is missing.');
              return;
            }

            const thumbsEl = document.querySelector('[data-product-overview] [data-product-thumbs]');
            let thumbsHTML = '';
            if (thumbsEl) {
              // Template V3
              thumbsHTML = thumbsEl.outerHTML.replace(/data-product-thumb/gi, 'data-product-zoom-thumb');
            } else {
              // Template V4
              const full_images = document.querySelectorAll('[data-product-overview] [data-product-full] .product-main__image');
              thumbsHTML = `<div aria-label="Select a product image" aria-orientation="vertical" aria-live="polite" class="product-images__thumbs hidden--mobile" role="tablist" tabindex="-1" data-product-zoom-thumbs>`;
              full_images.forEach((img, index) => {
                const thumbURL = img.dataset.thumb;
                const zoomURL = img.dataset.zoom;
                const altText = img.dataset.alt;
                thumbsHTML += `
                  <div class="product-images__thumb" id="control-slide-${index + 1}" role="tab" aria-selected="true" type="button" tabindex="0" data-product-zoom-thumb="" data-product-full-url="${thumbURL}" data-product-zoom-url="${zoomURL}">
                    <img class="product-images__thumb-image" src="${thumbURL}" alt="Thumbnail image - ${altText}" tabindex="-1" />
                  </div>
                `;
              });
              thumbsHTML += `</div>`;
            }

            zoomModalContent.innerHTML = `
              <div class="zoom-content">
                <div class="zoom-content__thumbs" data-zoom-thumbs>
                  ${thumbsHTML}
                </div>
                <div class="zoom-content__full" data-zoom-full>
                  <img src="${zoom_image}" alt="Zoomed image - ${zoom_image_alt}" width="100%" class="product-zoom__image" onclick="MicroModal.close('zoom-modal');" tabindex="-1" />
                </div>
              </div>
            `;
          });

          document.documentElement.style.overflow = 'hidden';

          const closeBtn = document.querySelector('#zoom-modal .close');
          if (closeBtn) {
            closeBtn.setAttribute('role', 'button');
            closeBtn.focus();
          }
        },
        onClose: () => {
          const zoomModalContent = document.querySelector('[data-product-zoom-modal]');
          if (zoomModalContent) zoomModalContent.innerHTML = '';
          document.documentElement.style.overflow = 'auto';
          const h1 = document.querySelector('[data-product-details] h1');
          if (h1) h1.focus();
        }
      });
    }

    // Zoom Modal - thumb
    if (e.target.matches('[data-product-zoom-thumb], [data-product-zoom-thumb] *')) {
      const item = e.target.closest('[data-product-zoom-thumb]');
      document.querySelector('[data-zoom-full]').innerHTML = `<img src="${item.dataset.productZoomUrl}" alt="Zoomed image" width="100%" onclick="MicroModal.close('zoom-modal');" class="product-zoom__image" tabindex="-1">`;
    }

    // Product thumb click
    if (e.target.matches('[data-product-thumb], [data-product-thumb] *')) {
      const item = e.target.closest('[data-product-thumb]');
      document.querySelector('[data-product-main]').setAttribute('aria-live', 'polite');
      let media_html = '';
      let img_alt = '';
      document.querySelector('.product-main').classList.remove('has-video', 'has-video--playing');

      if (item.dataset.productZoomUrl === 'video') {
        img_alt = item.querySelector('img').alt.replace('Thumbnail', 'Video');
        media_html += `<div aria-live="polite" aria-atomic="true" class="sr-only" data-product-media-status>Main product video is now playing</div>`;
        media_html += `
          <div class="product-main__video">
            <video playsinline disablepictureinpicture ${window.theme.breakpoints.current !== 'mobile' ? 'autoplay' : ''} muted loop preload="auto" class="product-main__video-player" tabindex="0" aria-label="Product video - ${img_alt}" aria-description="This video only visualizes the product and does not provide additional information" poster="${getSizedImageURL(item.dataset.productFullUrl, '1200x')}">
              <source src="${item.dataset.productVideo}" type="video/mp4">
              Your browser does not support the video tag.
            </video>
            <button type="button" class="product-main__controls" data-product-video-control></button>
          </div>
        `;
        document.querySelector('.product-main').classList.add('has-video', 'has-video--playing');
      } else {
        const isMobile = window.theme.breakpoints.current === 'mobile';
        img_alt = item.querySelector('img').alt.replace('Thumbnail', 'Image');
        media_html += `<div aria-live="polite" aria-atomic="true" class="sr-only" data-product-media-status>Main product image updated. ${img_alt}</div>`;
        
        // $('[data-product-main]').html(`
        //   <img class="product-main__image" src="${$item.data('product-full-url')}" 
        //        data-zoom="${$item.data('product-zoom-url')}" 
        //        data-modal="#zoom-modal" 
        //        alt="${$item.find('img').attr('alt').replace('Thumbnail', 'Image')}" />
        // `);

        // Don't forget to update the same image in variantImages.js and components/nosto/events.js for the image preloading
        media_html += `
          <img
            class="product-main__image"
            src="${getSizedImageURL(item.dataset.productFullUrl, isMobile ? '288x440' : '1200x')}"
            alt="${img_alt}"
            data-original="${item.dataset.productFullUrl}"
            data-zoom="${item.dataset.productZoomUrl}"
            data-modal="#zoom-modal"
            srcset="
              ${getSizedImageURL(item.dataset.productFullUrl, '150x230')} 150w,
              ${getSizedImageURL(item.dataset.productFullUrl, '288x440')} 288w,
              ${getSizedImageURL(item.dataset.productFullUrl, '414x631')} 414w,
              ${getSizedImageURL(item.dataset.productFullUrl, '550x')} 550w,
              ${getSizedImageURL(item.dataset.productFullUrl, '800x')} 800w,
              ${getSizedImageURL(item.dataset.productFullUrl, '1024x')} 1024w,
              ${getSizedImageURL(item.dataset.productFullUrl, '1200x')} 1200w,
              ${getSizedImageURL(item.dataset.productFullUrl, '1400x')} 1400w,
              ${getSizedImageURL(item.dataset.productFullUrl, '1600x')} 1600w
            "
            sizes="(max-width: 768px) calc(100vw - 40px), 33vw"
            fetchpriority="auto"
            width="100%"
            height="auto"
          />
        `;
      }
      document.querySelector('[data-product-main]').innerHTML = media_html;

      window.setTimeout(() => {
        const video = document.querySelector('.product-main__video-player');
        const video_controls = document.querySelector('[data-product-video-control]');

        if (video) {
          video.addEventListener('click', (event) => {
            if (video.paused) {
              video.play();
              event.target.closest('.product-main').classList.add('has-video--playing');
              document.querySelector('[data-product-full] [data-product-media-status]').innerText = 'Main product video is now playing';
            } else {
              video.pause();
              event.target.closest('.product-main').classList.remove('has-video--playing');
              document.querySelector('[data-product-full] [data-product-media-status]').innerText = 'Main product video is paused';
            }
          });
          video.addEventListener('touchend', (event) => {
            event.target.click();
          });
          if (video_controls) {
            video_controls.addEventListener('click', () => video.click());
            video_controls.addEventListener('touchend', () => video.click());
            video_controls.addEventListener('keydown', (event) => {
              if (event.code === 'Space' || event.code === 'Enter' || event.keyCode === 32 || event.keyCode === 13) {
                video.click();
              }
            });
          }
        }
      }, 10);
    }

    // Buy Now
    if (e.target.matches('[data-buy-now], [data-buy-now] *')) {
      e.preventDefault();
      e.stopPropagation();
      if (e.target.disabled) return;

      // https://community.shopify.com/c/shopify-design/cart-use-permalinks-to-pre-load-the-cart/td-p/613702#adding-a-buy-this-link-to-a-blog-post
      // http://yourstore.com/cart/#{variant_id}:#{quantity}(,...)
      const url = new URL(window.location.href);
      selected_variant_id = url.searchParams.get('variant');

      if (selected_variant_id !== null && selected_variant_id !== '') {
        window.location.href = `${window.Shopify.routes.root}cart/${selected_variant_id}:1`;
      }
    }

    // Click the wishlist icon from the product overview
    if (e.target.matches('[data-product-overview] [data-wishlist-clickable], [data-product-overview] [data-wishlist-clickable] *')) {
      if (typeof e.target.dataset.openSigninActionsModal !== 'undefined') return;

      const swymBtn = e.target.closest('[data-product-overview]').querySelector('.swym-button');

      if (swymBtn) swymBtn.click();

      propagateWishlistStateToStickyAddToCart();
    }

    // Sticky add to cart wishlist
    if (e.target.matches('[data-product-details-wishlist], [data-product-details-wishlist] *')) {
      const clickable = document.querySelector('[data-product-overview] [data-wishlist-clickable]');
      if (clickable) clickable.click();
    }
  });

  document.addEventListener('touchmove', (e) => {
    if (e.target.closest('[data-product-main]')) {
      is_mobile_move = true;
    }
  });

  // [ADA]
  document.addEventListener('keydown', (e) => {
    // Wishlist icon keyboard
    if (e.target.matches('[data-product-overview] [data-wishlist-clickable]')) {
      if (typeof e.target.dataset.openSigninActionsModal !== 'undefined') return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.target.click();
      }
    }

    // Sticky add to cart wishlist keyboard
    if (e.target.matches('[data-product-details-wishlist]')) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.target.click();
      }
    }

    // Product thumbs keyboard
    if (e.target.matches('[data-product-thumbs] [role="tab"]')) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.target.click();
      }
    }
  });

  window.setTimeout(() => {
    propagateWishlistStateToStickyAddToCart(true);
  }, 2000);

  return true;
};
